import supabaseClient from '@/api/supabaseClient';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';
import { BackendSuccessResponse } from '@/types/response/BackendSuccessResponse';
import { UpgradeSubscriptionRequest } from '$/requests/UpgradeSubscription.ts';
import { queryClient } from '@/main.tsx';

const useUpgradeSubscription = () => {
  const client = supabaseClient;

  const mutationFn = async (request: UpgradeSubscriptionRequest) => {
    return upgradeSubscription(client, request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
    },
  });
};

export default useUpgradeSubscription;

async function upgradeSubscription(
  client: SupabaseClient,
  request: UpgradeSubscriptionRequest
): Promise<BackendSuccessResponse<Record<string, never>>> {
  const { data, error } = await client.functions.invoke('upgrade_subscription', {
    body: { ...request },
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorResponse: BackendErrorResponse = await error.context.json();

    throw new Error(errorResponse.errors.join(', '));
  }

  return data;
}
